<template>
  <div class="card trending-merchants">
    <h2 class="card__heading">
      <translation en="Trending merchants" ch="热门商户"></translation>
    </h2>
    <div class="card__content">
      <div class="trending-merchants__content">
        <loading :loading="loading"></loading>
        <WideCampaignCard v-for="campaign in trendingCampaigns" :campaign="campaign"/>
      </div>
    </div>
  </div>
</template>

<script>

import WideCampaignCard from "@/components/WideCampaignCard.vue";
import Loading from './../components/Loading.vue';
import axios from "axios";
import Translation from "@/components/Translation.vue";

export default {
  name: 'TrendingMerchants',
  components: {
    WideCampaignCard,
    Loading,
    Translation
  },
  data() {
    return {
      loadingTrendingCampaigns: true,
      trendingCampaigns: [],
      loading: true
    }
  },

  methods: {
    async getTrendingMerchants() {

      let token = this.$getSessionToken();

      try {
        const response = await axios.get('https://apis.topstylemedia.com/index.php/wp-json/v1/trending-campaigns', {
          headers: {
            'Authorization': `Bearer ${token}`,
          }
        });
        this.trendingCampaigns = response.data;
        this.loading = false;
      } catch (error) {
        console.error('Error fetching trending merchants:', error);
        // Optionally handle the error here
      }
    }
  },

  mounted() {
    this.getTrendingMerchants();
  }


}
</script>

<style lang="scss" scoped>

@use "@/scss/mixins.scss";
@use "@/scss/variables.scss";
@import "../scss/styles.scss";

.trending-merchants{
  &__content{
    max-height: calc(100vh - 37rem);
    overflow: auto;
    width: 100%;
    min-height: 20rem;
  }
}



</style>


